ScoreTrekBattle.Settings.Squads = (function() {
    var _this, STATUS, CONFIG;

    CONFIG = {
        baseFilterOrder: ['countryId', 'seasonId', 'federationId', 'divisionId'],
        leagueFilterOrder: ['leagueId', 'groupId'],
        // Remembers the last chosen season across visits (falls back to current).
        SEASON_STORAGE_KEY: 'ScoreTrekBattle.Settings.Squads.Season'
    };

    function resetStatus() {
        STATUS = {
            active: false,
            isInline: false,
            view: null,
            $view: null,
            $list: null,
            seasonId: '',          // currently selected top-level season
            rows: {},              // squadId -> { data, view } (looked up by trigger-action handlers)
            rosterLoads: [],       // pending roster requests of the current render
            cascadeRequestId: 0,
            cascadeRestoring: false
        };
    }
    resetStatus();

    // ── View lifecycle ───────────────────────────────────────

    function onInline() {
        return new Promise(function(resolve) {
            STATUS.isInline = true;
            resolve({});
        });
    }

    function disableBreadcrumbLink($view) {
        var $link;

        $link = $view.find('[data-id="settingsLink"]');

        $link.replaceWith(
            $('<span>').addClass($link.attr('class')).text($link.text())
        );
    }

    function onViewRender() {
        return new Promise(function(resolve) {
            if (!STATUS.isInline) {
                ScoreTrekBattle.View.updateMenu('/settings');
            }
            ScoreTrekBattle.Template.render('settings/squads/list').then(view => {
                STATUS.active = true;
                STATUS.view = view;
                STATUS.$view = view.$view;
                STATUS.$list = STATUS.$view.find('[data-id="list"]');

                if (STATUS.isInline) {
                    disableBreadcrumbLink(STATUS.$view);
                }

                resolve(STATUS.$view);
            });
        });
    }

    function onViewLoad() {
        return new Promise(function(resolve) {
            STATUS.active = true;
            initSeasonSelector().then(updateList);
            resolve();
        });
    }

    // ── Season selector (top-level scope for the whole editor) ───

    function initSeasonSelector() {
        return new Promise(function(resolve) {
            var control;

            control = STATUS.view.controls.seasonId;

            Api.request('/battle/league/seasons').then(result => {
                var list, stored;

                list = result.list || [];
                control.setOptions(DataHandler.arrayToOptions(list, 'id', 'name'));

                // Restore the last chosen season if still available, else the one
                // the backend flags as current.
                stored = localStorage.getItem(CONFIG.SEASON_STORAGE_KEY) || '';
                STATUS.seasonId = list.some(season => season.id === stored)
                    ? stored
                    : (result.currentId || (list.length ? list[0].id : ''));

                control.set(STATUS.seasonId);

                control.on('change', function() {
                    STATUS.seasonId = this.get();
                    localStorage.setItem(CONFIG.SEASON_STORAGE_KEY, STATUS.seasonId);
                    updateList();
                });
            }).catch(ignore => {
            }).finally(resolve);
        });
    }

    function onViewUpdate() {
        return new Promise(function(resolve) {
            setTimeout(() => {
                if (!STATUS.$list) {
                    return;
                }
                updateList();
            }, 0);
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            resetStatus();
            resolve();
        });
    }

    // ── Row registry (trigger-action context lookup) ─────────

    function getRow(element) {
        var squadId;
        squadId = $(element).closest('[data-squad-id]').attr('data-squad-id');
        return (squadId && STATUS.rows.hasOwnProperty(squadId)) ? STATUS.rows[squadId] : null;
    }

    // ── Squad list ───────────────────────────────────────────

    function loadSquads() {
        return new Promise(function(resolve, reject) {
            Api.request('/battle/squads', {seasonId: STATUS.seasonId || ''}).then(result => {
                resolve(result.list || []);
            }).catch(reject);
        });
    }

    function updateList() {
        ScoreTrekBattle.View.loading('Settings.Squads.updateList', true);
        return loadSquads().then(squads => {
            return renderSquads(squads);
        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            ScoreTrekBattle.View.loading('Settings.Squads.updateList', false);
        });
    }

    function focusSquad(squadId) {
        var $squad, $dialog, viewportHeight;

        if (!STATUS.$list || !squadId) {
            return;
        }

        $squad = STATUS.$list.find(`[data-squad-id="${squadId}"]`);

        if ($squad.length === 0) {
            return;
        }

        ScoreTrekBattle.Tournament.Live.forceToggleOpen($squad);

        // Die Liste laeuft im Dialog wie als eigene Ansicht — was von ihr
        // sichtbar ist, entscheidet mal der Dialog, mal das Fenster.
        $dialog = $squad.closest('.dialog');
        viewportHeight = ($dialog.length > 0) ? $dialog.height() : window.innerHeight;

        AnimationHandler.scrollIntoView($squad, $squad.outerHeight() > (0.8 * viewportHeight)).then($element => {
            AnimationHandler.pulse($element);
        }).catch(ignore => {});
    }

    function groupSquads(squads) {
        var federations, order;

        federations = {};
        order = [];

        squads.forEach(squad => {
            var federationId, divisionId, federation;

            federationId = squad.federationId || '';
            divisionId = squad.divisionId || '';

            if (!federations.hasOwnProperty(federationId)) {
                federations[federationId] = {
                    federationId: federationId,
                    federationName: squad.federationName || __i18n('squad/base/unassigned'),
                    federationLogo: squad.federationLogo || '',
                    divisions: {},
                    divisionOrder: []
                };
                order.push(federationId);
            }

            federation = federations[federationId];

            if (!federation.divisions.hasOwnProperty(divisionId)) {
                federation.divisions[divisionId] = {
                    divisionId: divisionId,
                    divisionName: squad.divisionName || __i18n('squad/base/unassigned'),
                    divisionIcon: squad.divisionIcon || '',
                    squads: []
                };
                federation.divisionOrder.push(divisionId);
            }

            federation.divisions[divisionId].squads.push(squad);
        });

        return order.map(federationId => {
            var federation;

            federation = federations[federationId];

            return {
                federationId: federation.federationId,
                federationName: federation.federationName,
                federationLogo: federation.federationLogo,
                divisions: federation.divisionOrder.map(divisionId => {
                    return federation.divisions[divisionId];
                })
            };
        });
    }

    function renderSquads(squads) {
        return new Promise(function(resolve, reject) {
            var promises;

            STATUS.rows = {};
            STATUS.rosterLoads = [];
            STATUS.$list.empty();

            promises = groupSquads(squads).map(renderFederation);

            Promise.all(promises).then($federations => {
                STATUS.$list.append($federations);
                resolve();
            }).catch(reject);
        });
    }

    function applyToggle($view, toggleId) {
        var isOpen;

        isOpen = ScoreTrekBattle.Tournament.Live.getOpenState(toggleId);

        $view.attr({
            'data-toggle-id': toggleId,
            'data-is-open': isOpen ? 'yes' : 'no'
        });

        if (!isOpen) {
            $view.find('[data-ref="toggle"]').first().hide();
        }
    }

    function applyFederationLogo($view, logo) {
        var $logo;

        $logo = $view.find('[data-id="federationLogo"]');

        if (!logo) {
            $logo.remove();
            return;
        }

        $logo.css('background-image', `url('${logo}')`);
    }

    function applyDivisionIcon($view, icon) {
        var $icon;

        $icon = $view.find('[data-id="divisionIcon"]');

        if (!icon) {
            $icon.remove();
            return;
        }

        $icon.css('background-image', `url('/res/img/game/${icon}.svg')`);
    }

    function countSquads(federation) {
        return federation.divisions.reduce((total, division) => {
            return total + division.squads.length;
        }, 0);
    }

    function updateGroupCount($group) {
        if ($group.parent().length === 0) {
            return;
        }
        $group.find('.squad-count').first().text($group.find('.squad').length);
    }

    function renderFederation(federation) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.Template.render('settings/squads/federation', {
                federationId: federation.federationId,
                federationName: federation.federationName,
                squadCount: countSquads(federation)
            }, true).then(view => {
                applyToggle(view.$view, `squads_${STATUS.seasonId}_${federation.federationId || 'none'}`);
                applyFederationLogo(view.$view, federation.federationLogo);

                Promise.all(federation.divisions.map(division => {
                    return renderDivision(federation, division);
                })).then($divisions => {
                    view.$view.find('[data-id="divisions"]').append($divisions);
                    resolve(view.$view);
                }).catch(reject);
            }).catch(reject);
        });
    }

    function renderDivision(federation, division) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.Template.render('settings/squads/division', {
                divisionId: division.divisionId,
                divisionName: division.divisionName,
                squadCount: division.squads.length
            }, true).then(view => {
                applyToggle(view.$view, `squads_${STATUS.seasonId}_${federation.federationId || 'none'}_${division.divisionId || 'none'}`);
                applyDivisionIcon(view.$view, division.divisionIcon);

                Promise.all(division.squads.map(renderSquad)).then($squads => {
                    view.$view.find('[data-id="squads"]').append($squads);
                    resolve(view.$view);
                }).catch(reject);
            }).catch(reject);
        });
    }

    function renderSquad(squad) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.Template.render('settings/squads/item', {squad: squad}).then(view => {
                var data;

                data = {
                    id: squad.id,
                    label: squad.label || '',
                    leagueLabel: squad.leagueLabel || '',
                    countryName: squad.countryName || '',
                    seasonName: squad.seasonName || '',
                    federationName: squad.federationName || '',
                    divisionName: squad.divisionName || '',
                    assignedIds: [],
                    assignedPlayerIds: []
                };
                CONFIG.baseFilterOrder.concat(CONFIG.leagueFilterOrder).forEach(filterKey => {
                    data[filterKey] = squad[filterKey] || '';
                });

                STATUS.rows[data.id] = {data: data, view: view};

                updateGroupDisplay(view.$view, data);
                loadRoster(view.$view, data);

                resolve(view.$view);
            }).catch(reject);
        });
    }

    // ── Squad persistence ────────────────────────────────────

    function saveSquad(data) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Settings.Squads.save', true);
            Api.request('/battle/squad/save', {
                id: data.id || '',
                groupId: data.groupId || ''
            }).then(result => {
                resolve(result.squad);
            }).catch(reject).finally(() => {
                ScoreTrekBattle.View.loading('Settings.Squads.save', false);
            });
        });
    }

    function createSquad(base) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Settings.Squads.create', true);
            Api.request('/battle/squad/create', base).then(result => {
                resolve(result.squad);
            }).catch(reject).finally(() => {
                ScoreTrekBattle.View.loading('Settings.Squads.create', false);
            });
        });
    }

    function confirmDeleteSquad(data) {
        return new Promise(function(resolve, reject) {
            chmDialog.confirm(__i18n('dialog/confirm/delete/text', {colorClass: 'color-blue', reference: data.label}, true), {
                title: __i18n('dialog/confirm/delete/title'),
                buttonYes: __i18n('button/delete'),
                buttonNo: __i18n('button/cancel')
            }).then(() => {
                if (!data.id) {
                    resolve(true);
                    return;
                }
                ScoreTrekBattle.View.loading('Settings.Squads.delete', true);
                Api.request('/battle/squad/delete', {id: data.id}).then(() => {
                    resolve(true);
                }).catch(reject).finally(() => {
                    ScoreTrekBattle.View.loading('Settings.Squads.delete', false);
                });
            }).catch(() => {
                resolve(false);
            });
        });
    }

    // ── Roster ───────────────────────────────────────────────

    function loadRoster($squad, data) {
        var request;

        if (!data.id) {
            return Promise.resolve();
        }

        ScoreTrekBattle.View.loadingBackground('Settings.Squads.roster', true);
        request = Api.request('/battle/squad/roster', {squadId: data.id}).then(result => {
            var roster;
            roster = result.roster || [];
            data.assignedIds = roster.map(player => player.id);
            data.assignedPlayerIds = roster.map(player => player.playerId).filter(Boolean);
            return renderRoster($squad, data, roster);
        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            ScoreTrekBattle.View.loadingBackground('Settings.Squads.roster', false);
        });

        STATUS.rosterLoads.push(request);

        return request;
    }

    // Die Kader kommen einzeln nach. Erst wenn sie stehen, hat die Liste ihre
    // endgueltige Hoehe — vorher zielt jeder Sprung ins Leere.
    function whenListSettled() {
        return Promise.all(STATUS.rosterLoads);
    }

    function renderRoster($squad, data, roster) {
        var $roster, promises;

        $roster = $squad.find('[data-id="roster"]');
        promises = [];
        roster.forEach(player => {
            promises.push(renderRosterItem(data, player));
        });

        $roster.empty();
        return Promise.all(promises).then($items => {
            $roster.append($items);
        });
    }

    function decorateRosterItem($view, player) {
        var app, isAccount, $origin;

        // The virtual "player" field carries the rendered app-player data for
        // linked players and the custom placeholder for free-text ones.
        app = player.player || {};
        isAccount = !!player.playerId;

        if (app.thumbnail) {
            $view.find('[data-id="avatar"]').css('background-image', `url('${app.thumbnail}')`);
        }

        // Pro badge overlay — mirrors the player search rendering.
        $view.toggleClass('isProPlayer', !!app.pro_account);

        // Origin marker: manually created players carry the exact same pink
        // "custom" badge as the tournament participant lists; linked accounts
        // stay clean (identified by their avatar / pro badge only).
        $view.attr('data-origin', isAccount ? 'account' : 'manual');
        $origin = $view.find('[data-id="origin"]');
        if (isAccount) {
            $view.removeAttr('title');
            $origin.empty();
        } else {
            $view.attr('title', __i18n('player/custom'));
            $origin.html('<span class="badge bg-color-white color-pink" data-info-popup="squad/player/manualInfo"><i class="fa-solid fa-user-slash"></i></span>');
        }
    }

    function renderRosterItem(data, player) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render('settings/squads/rosterItem', {player: player}).then(view => {
                decorateRosterItem(view.$view, player);

                // Role is a form control; its change is a control event, not a
                // click handler — assign immediately and revert on failure.
                view.controls.role.set(player.role);
                view.controls.role.on('change', function() {
                    var role = this.get();
                    assignPlayer(data.id, {leaguePlayerId: player.id}, role).then(() => {
                        player.role = role;
                    }).catch(error => {
                        chmDialog.error(error);
                        view.controls.role.set(player.role);
                    });
                });

                resolve(view.$view);
            });
        });
    }

    function assignPlayer(squadId, fields, role) {
        return Api.request('/battle/squad/player/assign', $.extend({
            squadId: squadId,
            role: role || 'starter'
        }, fields));
    }

    function removePlayer(squadId, leaguePlayerId) {
        return Api.request('/battle/squad/player/remove', {
            squadId: squadId,
            leaguePlayerId: leaguePlayerId
        });
    }

    function openPlayerSearch($squad, data) {
        ScoreTrekBattle.PlayerSearch.open({
            placeholder: __i18n('squad/player/search'),
            allowOtherClubs: true,
            createLabel: function(name) {
                return __i18n('squad/player/createNamed', {name: name}, true);
            },
            pool: ScoreTrekBattle.PlayerSearch.clubPool({
                isAdded: function(leaguePlayer) {
                    return (data.assignedIds || []).indexOf(leaguePlayer.id) >= 0;
                },
                onSelect: function(leaguePlayer) {
                    return assignPlayer(data.id, {leaguePlayerId: leaguePlayer.id}).then(() => {
                        if ((data.assignedIds || []).indexOf(leaguePlayer.id) < 0) {
                            data.assignedIds = (data.assignedIds || []).concat(leaguePlayer.id);
                        }
                        loadRoster($squad, data);
                        return true;
                    }).catch(error => {
                        chmDialog.error(error);
                        return false;
                    });
                }
            }),
            isAdded: function(playerId) {
                return (data.assignedPlayerIds || []).indexOf(playerId) >= 0;
            },
            onSelect: function(player) {
                return assignPlayer(data.id, {playerId: player.id}).then(() => {
                    if ((data.assignedPlayerIds || []).indexOf(player.id) < 0) {
                        data.assignedPlayerIds = (data.assignedPlayerIds || []).concat(player.id);
                    }
                    loadRoster($squad, data);
                    return true;
                }).catch(error => {
                    chmDialog.error(error);
                    return false;
                });
            },
            onCreate: function(name) {
                return assignPlayer(data.id, {fullName: name}).then(() => {
                    loadRoster($squad, data);
                    return true;
                }).catch(error => {
                    chmDialog.error(error);
                    return false;
                });
            }
        });
    }

    function openCreateDialog() {
        ScoreTrekBattle.Template.render('settings/squads/createDialog').then(dialogView => {
            var controls, context, dialog;

            controls = dialogView.controls;

            context = {
                order: CONFIG.baseFilterOrder.concat(CONFIG.leagueFilterOrder),
                fixed: {},
                placeholder: `-- ${__i18n('filter/pleaseSelect')} --`,
                placeholders: {
                    leagueId: `-- ${__i18n('matchday/editor/choose')} --`,
                    groupId: `-- ${__i18n('matchday/editor/choose')} --`
                }
            };

            attachCascade(controls, context);
            loadCascadeFilters(controls, context, '', {seasonId: STATUS.seasonId || ''});

            dialog = chmDialog({
                title: __i18n('squad/base/dialog/title'),
                content: dialogView.$view,
                isPersistant: true,
                buttons: [
                    {
                        action: () => {
                            var values, errors;

                            values = collectValues(controls, context.order);
                            errors = missingRequiredFields(values, context.order);

                            if (errors.length === 0) {
                                submitCreate(values, dialog);
                            } else {
                                dialogView.forms.squadCreate.errors(errors);
                            }

                            return false;
                        },
                        label: __i18n('squad/create'),
                        primary: true
                    },
                    {
                        label: __i18n('button/cancel')
                    }
                ]
            });
        });
    }

    function missingRequiredFields(values, order) {
        return order.filter(filterKey => {
            return !values[filterKey];
        }).map(filterKey => {
            return {
                field: filterKey,
                message: __i18n('squad/base/required')
            };
        });
    }

    function submitCreate(base, dialog) {
        createSquad(base).then(squad => {
            if (squad.seasonId && (squad.seasonId !== STATUS.seasonId)) {
                STATUS.seasonId = squad.seasonId;
                localStorage.setItem(CONFIG.SEASON_STORAGE_KEY, STATUS.seasonId);
                STATUS.view.controls.seasonId.set(STATUS.seasonId);
            }
            // Erst wenn der Anlege-Dialog wirklich zu ist und die Liste
            // vollstaendig steht, laesst sich die neue Mannschaft anspringen.
            Promise.all([
                dialog.close(),
                updateList().then(whenListSettled)
            ]).then(() => {
                setTimeout(() => {
                    focusSquad(squad.id);
                }, 0);
            });

            ScoreTrekBattle.Event.trigger('squad.updated', squad);
        }).catch(error => {
            chmDialog.error(error);
        });
    }

    function openGroupPicker(data, onApply) {
        ScoreTrekBattle.Template.render('settings/squads/leaguePicker', {
            countryName: data.countryName,
            seasonName: data.seasonName,
            federationName: data.federationName,
            divisionName: data.divisionName
        }, true).then(pickerView => {
            var controls, context, restore;

            controls = pickerView.controls;

            context = {
                order: CONFIG.leagueFilterOrder,
                fixed: collectFixedBase(data),
                placeholder: `-- ${__i18n('matchday/editor/choose')} --`
            };

            restore = {};
            CONFIG.leagueFilterOrder.forEach(filterKey => {
                restore[filterKey] = data[filterKey] || '';
            });

            attachCascade(controls, context);
            loadCascadeFilters(controls, context, '', restore);

            chmDialog({
                title: __i18n('squad/league/dialog/title'),
                content: pickerView.$view,
                isPersistant: true,
                buttons: [
                    {
                        action: () => {
                            var errors;

                            errors = missingRequiredFields(collectValues(controls, CONFIG.leagueFilterOrder), CONFIG.leagueFilterOrder);

                            if (errors.length > 0) {
                                pickerView.forms.leaguePicker.errors(errors);
                                return false;
                            }

                            applyGroupSelection(controls, data);
                            onApply();
                        },
                        label: __i18n('button/apply'),
                        primary: true
                    },
                    {
                        label: __i18n('button/cancel')
                    }
                ]
            });
        });
    }

    function collectFixedBase(data) {
        var fixed;

        fixed = {};
        CONFIG.baseFilterOrder.forEach(filterKey => {
            if (data[filterKey]) {
                fixed[filterKey] = data[filterKey];
            }
        });

        return fixed;
    }

    function controlValue(controls, filterKey) {
        var control = controls[filterKey];
        return (control && (typeof control.get === 'function')) ? String(control.get() || '').trim() : '';
    }

    function collectValues(controls, order) {
        var values;

        values = {};
        order.forEach(filterKey => {
            values[filterKey] = controlValue(controls, filterKey);
        });

        return values;
    }

    function applyGroupSelection(controls, data) {
        CONFIG.leagueFilterOrder.forEach(filterKey => {
            data[filterKey] = controlValue(controls, filterKey);
        });

        data.leagueLabel = buildLeagueLabel(controls);
    }

    function buildLeagueLabel(controls) {
        function optionText(filterKey) {
            var control, text;
            control = controls[filterKey];
            if (!control || !control.$view) {
                return '';
            }
            text = String(control.$view.find('select option:selected').text() || '').trim();
            return /^--.*--$/.test(text) ? '' : text;
        }

        return CONFIG.leagueFilterOrder.map(optionText).filter(Boolean).join(' · ');
    }

    function updateGroupDisplay($squad, data) {
        var label;

        label = data.leagueLabel || '';

        $squad.find('[data-id="selectedGroupLabel"]').text(label || __i18n('squad/league/none')).attr('title', label || '');
        $squad.find('[data-id="selectedGroup"]').attr('data-empty', label ? 'no' : 'yes');
    }

    function attachCascade(controls, context) {
        context.order.forEach(filterKey => {
            controls[filterKey].on('change', function() {
                if (STATUS.cascadeRestoring) {
                    return;
                }
                adoptLeagueDivision(controls, context, filterKey);
                loadCascadeFilters(controls, context, filterKey);
            });
        });
    }

    function collectLeagueDivisions(values) {
        var map;

        map = {};

        (Array.isArray(values) ? values : []).forEach(group => {
            Object.keys(group.options || {}).forEach(leagueId => {
                var option;
                option = group.options[leagueId];
                if (option && option.divisionId) {
                    map[leagueId] = option.divisionId;
                }
            });
        });

        return map;
    }

    function adoptLeagueDivision(controls, context, filterKey) {
        var divisionId;

        if ((filterKey !== 'leagueId') || !controls.divisionId) {
            return;
        }

        divisionId = (context.leagueDivisions || {})[controlValue(controls, 'leagueId')] || '';

        if (divisionId !== '') {
            controls.divisionId.set(divisionId);
        }
    }

    function hasOptions(options) {
        if (Array.isArray(options)) {
            return options.some(group => {
                return Object.keys(group.options || {}).length > 0;
            });
        }
        return Object.keys(options || {}).length > 0;
    }

    function cascadePlaceholder(controls, context, filterKey, options) {
        if ((filterKey === 'groupId') && (options !== undefined) && !hasOptions(options) && controlValue(controls, 'leagueId')) {
            return `-- ${__i18n('filter/none')} --`;
        }

        return (context.placeholders && context.placeholders[filterKey]) || context.placeholder;
    }

    function soleGroupOption(options) {
        var keys, sole;

        if (Array.isArray(options)) {
            return null;
        }

        keys = Object.keys(options || {});

        if (keys.length !== 1) {
            return null;
        }

        sole = {};
        sole[keys[0]] = `-- ${__i18n('filter/none')} --`;

        return sole;
    }

    function getCascadeValues(controls, context) {
        var filters;

        filters = {};
        context.order.forEach(filterKey => {
            var value;
            value = controlValue(controls, filterKey);
            if (value) {
                filters[filterKey] = value;
            }
        });
        return filters;
    }

    function loadCascadeFilters(controls, context, changedKey, restoreValues) {
        var requestId, filters;

        STATUS.cascadeRequestId = (STATUS.cascadeRequestId || 0) + 1;
        requestId = STATUS.cascadeRequestId;

        filters = $.extend({}, restoreValues || getCascadeValues(controls, context), context.fixed);

        Api.request('/battle/league/matchday/filters', {
            filters: filters,
            changed: changedKey
        }).then(result => {
            var allFilters, disabled;

            if (requestId !== STATUS.cascadeRequestId) {
                return;
            }
            if (!result || !result.filters) {
                return;
            }

            allFilters = result.filters;
            disabled = result.disabled || [];

            STATUS.cascadeRestoring = true;

            disabled.forEach(filterKey => {
                if (context.order.indexOf(filterKey) >= 0) {
                    resetPickerFilter(controls, filterKey, cascadePlaceholder(controls, context, filterKey));
                    disablePickerFilter(controls, filterKey);
                }
            });

            context.order.forEach(filterKey => {
                var options, sole;
                if (!allFilters.hasOwnProperty(filterKey)) {
                    return;
                }
                if (filterKey === 'leagueId') {
                    context.leagueDivisions = collectLeagueDivisions(allFilters[filterKey].values || {});
                }
                options = ScoreTrekBattle.League.Select.formatOptions(allFilters[filterKey].values || {});
                sole = (filterKey === 'groupId') ? soleGroupOption(options) : null;
                if (sole === null) {
                    controls[filterKey].setOptions(options, {'': cascadePlaceholder(controls, context, filterKey, options)});
                } else {
                    controls[filterKey].setOptions(sole);
                }
                enablePickerFilter(controls, filterKey);
                if (restoreValues && restoreValues[filterKey]) {
                    controls[filterKey].set(restoreValues[filterKey]);
                }
            });

            // Preselect the club's federation (country + federation) on a fresh
            // dialog when nothing has been chosen yet — mirrors the matchday editor.
            if (result.preselect) {
                ['countryId', 'federationId'].forEach(filterKey => {
                    if (controls[filterKey] && result.preselect[filterKey] && (context.order.indexOf(filterKey) >= 0)) {
                        controls[filterKey].set(result.preselect[filterKey]);
                    }
                });
            }

            STATUS.cascadeRestoring = false;
        }).catch(ignore => {
            STATUS.cascadeRestoring = false;
        });
    }

    function enablePickerFilter(controls, filterKey) {
        var control;
        control = controls[filterKey];
        if (!control) {
            return;
        }
        control.$view.removeClass('isDisabled');
        control.$view.find('select').prop('disabled', false);
    }

    function disablePickerFilter(controls, filterKey) {
        var control;
        control = controls[filterKey];
        if (!control) {
            return;
        }
        control.$view.addClass('isDisabled');
        control.$view.find('select').prop('disabled', true);
    }

    function resetPickerFilter(controls, filterKey, placeholder) {
        var control;
        control = controls[filterKey];
        if (!control) {
            return;
        }
        control.setOptions({}, {'': placeholder});
        control.set(null);
    }

    _this = {
    };

    ScoreTrekBattle.View.register('/settings/squads', () => { return onViewRender(); }, onViewLoad, onViewUpdate, onViewUnload, null, onInline);

    // ── Trigger-action handlers (declarative, no click handlers) ──

    ScoreTrekBattle.Event.on('action.squad.add', function() {
        if (!STATUS.active) {
            return;
        }

        openCreateDialog();
    });

    ScoreTrekBattle.Event.on('action.squad.delete', function() {
        var row = getRow(this);
        if (!row) {
            return;
        }
        confirmDeleteSquad(row.data).then(deleted => {
            if (!deleted) {
                return;
            }
            delete STATUS.rows[row.data.id];
            row.view.$view.slideUp(function() {
                var $division, $federation;

                $division = row.view.$view.closest('.squad-division');
                $federation = row.view.$view.closest('.squad-federation');

                row.view.$view.remove();

                if ($division.find('.squad').length === 0) {
                    $division.remove();
                }
                if ($federation.find('.squad').length === 0) {
                    $federation.remove();
                }

                updateGroupCount($division);
                updateGroupCount($federation);

                ScoreTrekBattle.Event.trigger('squad.updated', null);
            });
        }).catch(error => {
            chmDialog.error(error);
        });
    });

    ScoreTrekBattle.Event.on('action.squad.group.choose', function() {
        var row = getRow(this);
        if (!row) {
            return;
        }
        openGroupPicker(row.data, function() {
            // Reflect the client-built label immediately, then persist.
            updateGroupDisplay(row.view.$view, row.data);
            saveSquad(row.data).then(saved => {
                row.data.groupId = saved.groupId || '';
                row.data.leagueId = saved.leagueId || '';
                row.data.leagueLabel = saved.leagueLabel || '';
                updateGroupDisplay(row.view.$view, row.data);
                ScoreTrekBattle.Event.trigger('squad.updated', saved);
            }).catch(error => {
                chmDialog.error(error);
            });
        });
    });

    ScoreTrekBattle.Event.on('action.squad.player.add', function() {
        var row = getRow(this);
        if (!row) {
            return;
        }
        openPlayerSearch(row.view.$view, row.data);
    });

    ScoreTrekBattle.Event.on('action.squad.player.remove', function() {
        var row, leaguePlayerId;
        row = getRow(this);

        if (!row) {
            return;
        }

        leaguePlayerId = $(this).closest('[data-league-player-id]').attr('data-league-player-id');

        if (!leaguePlayerId) {
            return;
        }

        chmDialog.confirm(__i18n('dialog/confirm/remove/text', {colorClass: 'color-blue', reference: $(this).closest('[data-league-player-id]').find('[data-id="playerName"]').text()}, true), {
            title: __i18n('dialog/confirm/remove/title'),
            buttonYes: __i18n('button/remove'),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            removePlayer(row.data.id, leaguePlayerId).then(() => {
                loadRoster(row.view.$view, row.data);
            }).catch(error => {
                chmDialog.error(error);
            });
        }).catch(ignore => {});
    });

    return _this;
})();
